import {Expo, Power2, TimelineMax, TweenMax} from "gsap";

const classes = {
    open: 'open'
}

const selectors = {
    accordion: '[js-accordion]',
    head: '[js-accordion-head]',
    content: '[js-accordion-content]',
    button: '[js-accordion-button]'
};

const animations = {
    content: {
        delay: .1,
        duration: .8,
        in: {
            height: {height: 'auto', ease: Expo.easeInOut},
            fade: {opacity: 1, ease: Expo.easeInOut}
        },
        out: {
            height: {height: 0, ease: Expo.easeInOut},
            fade: {opacity: 0, ease: Expo.easeInOut},
        }
    },
    button: {
        duration: .4,
        delay: .4,
        in: {rotation: 180},
        out: {rotation: 0}
    }
}

const accordions = document.querySelectorAll(selectors.accordion);

if (accordions) {

    /**
     * On bind le click pour ouvrir / fermer l'accordéon
     */
    accordions.forEach(accordion => {
        const head = accordion.querySelector(selectors.head);
        head.addEventListener('click', () => {
            const content = accordion.querySelector(selectors.content);
            const button = accordion.querySelector(selectors.button);

            if (accordion.classList.contains(classes.open)) {
                TweenMax.to(content, animations.content.duration, animations.content.out.fade);
                TweenMax.to(content, animations.content.duration, animations.content.out.height).delay(animations.content.delay);
                TweenMax.to(button, animations.button.duration, animations.button.out).delay(animations.button.delay);
                accordion.classList.remove(classes.open)
            } else {
                TweenMax.to(content, animations.content.duration, animations.content.in.height);
                TweenMax.to(content, animations.content.duration, animations.content.in.fade).delay(animations.content.delay);
                TweenMax.to(button, animations.button.duration, animations.button.in).delay(animations.button.delay);
                accordion.classList.add(classes.open)
            }
        })
    });
}
